import React from 'react';

class RenderCountComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      renderCount: 0,
    };
  }

  componentDidUpdate() {
      console.log('Component Did Mount ');
    // Увеличиваем счетчик рендеров при обновлении компонента
    // this.setState((prevState) => ({
    //   renderCount: prevState.renderCount + 1,
    // }));

    console.log(`Количество рендеров: ${this.state.renderCount}`);
  }

  render() {
    return (
      <div>
        <p>Этот компонент был перерисован {this.state.renderCount} раз(а).</p>
      </div>
    );
  }
}

export default RenderCountComponent;